module.exports = __webpack_public_path__ + "staticPO/img/payerror.5ebc1d2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payerror.gif
// module id = h3fd
// module chunks = 1